import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { RestangularModule, Restangular } from "ngx-restangular";
@Injectable()
export class AssessmentHeaderService {
  private baseUrl = "/api/v1"; // Replace with your Laravel API URL
  private baseUrlNew = "https://qhsebe.ilooopsqhse.com/api/v1";

  constructor(private restangular: Restangular, private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token =
      localStorage.getItem("access_token") ||
      localStorage.getItem("refresh_token");
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }

  getAllAssessmentHeaders(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.baseUrl}/assessment-headers`, { headers });
  }

  getAssessmentHeaderById(id: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.baseUrl}/assessment-headers/${id}`, {
      headers,
    });
  }

  createAssessmentHeader(data: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(`${this.baseUrlNew}/assessment-headers`, data, {
      headers,
    });
  }

  updateAssessmentHeader(id: number, data: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.put(`${this.baseUrl}/assessment-headers/${id}`, data, {
      headers,
    });
  }

  // deleteAssessmentHeader(id: number): Observable<any> {
  //   const headers = this.getHeaders();
  //   return this.http.delete(`${this.baseUrl}/assessment-headers/${id}`, {
  //     headers,
  //   });
  // }



  public deleteAssessmentHeader(id) {
    return this.restangular.one("deleteAssessmentHeader/" + id);
  }

  public getCreateAss() {
    return this.restangular.one("getCreateAss");
  }




  public getCreateAssEdit_01(id) {
    return this.restangular.one("getCreateAssEdit_01/" + id);
  }


  public getAssEditEmp() {
    return this.restangular.one("getAssEditEmp");
  }

  public deleteEmpAss(id) {
    return this.restangular.one("deleteEmpAss/" + id);
  }

  public updateCreatedAss(id) {
    return this.restangular.one("updateCreatedAss/" + id);
  }

  public updateObjectiveReportHeader(id) {
    return this.restangular.one("updateObjectiveReportHeader/" + id);
  }
  

}



// WEBPACK FOOTER //
// /app/src/app/services/assessment-header.service.ts